export const comments_3389321 = {"data":{"data":[],"links":{}}}